import { render } from "./ProfileApp.vue?vue&type=template&id=f5fd2620&scoped=true"
import script from "./ProfileApp.vue?vue&type=script&lang=js"
export * from "./ProfileApp.vue?vue&type=script&lang=js"

import "./ProfileApp.vue?vue&type=style&index=0&id=f5fd2620&lang=sass&scoped=true"
import "./ProfileApp.vue?vue&type=style&index=1&id=f5fd2620&lang=sass"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5fd2620"]])

export default __exports__